import {
  tokenizeRoute,
  REVIEW_TAGS,
  CREATE_REVIEW_TAG,
  ADD_REVIEW_TAG_TO_STUDY,
} from 'query/routes';
import { getCsrfToken } from 'query';
import { NonRetriableError } from 'query/errors';
import { getReviewId } from 'query/review/Review';

type TagPost = {
  reviewId: string;
  tagName: string;
};
export type ReviewTag = {
  id: number;
  name: string;
};

export const getTags = async (): Promise<ReviewTag[]> => {
  const reviewId = getReviewId();
  if (!reviewId)
    throw new Error("Couldn't get Review ID. Is this part of a review?");

  const route = tokenizeRoute(REVIEW_TAGS, { review_id: reviewId });

  const response = await fetch(route.toString(), {
    method: 'GET',
    headers: { Accept: 'application/json' },
  });

  if (!response.ok) {
    const message = `Failed to fetch tags: ${response.status}`;
    // 5xx is usually transient, so let React Query retry it
    if (response.status >= 500) throw new Error(message);
    throw new NonRetriableError(String(response.status), message);
  }

  return (await response.json()).tags;
};

export const createTag = async ({
  reviewId,
  tagName,
}: TagPost): Promise<ReviewTag> => {
  const route = tokenizeRoute(CREATE_REVIEW_TAG, { review_id: reviewId });

  const response = await fetch(route.toString(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken(),
    },
    body: JSON.stringify({ name: tagName }),
  });

  if (!response.ok) {
    throw new Error('Something went wrong');
  }

  return response.json();
};

export const addTagsToStudies = async (
  reviewId: string,
  studyIds: string[],
  tags: string[]
): Promise<Response> => {
  const route = tokenizeRoute(ADD_REVIEW_TAG_TO_STUDY, { review_id: reviewId });

  const response = await fetch(route.toString(), {
    method: 'POST',
    body: JSON.stringify({ study_ids: studyIds, tags }),
    headers: { 'Content-Type': 'application/json' },
  });

  if (!response.ok) {
    throw new Error('Something went wrong');
  }

  return response;
};
